import styled from 'styled-components';

export const LoadingContainer = styled.div`
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    img {
      height: 150px;
      width: 150px;
    }
  }
`;
